import { LinkedDataModel } from './linked-data.model';
import { DesignObjectMentionMetadataType } from '../../enum/page-mention-metadata-type.enum';

export class NumberLinkedDataModel extends LinkedDataModel<number> {
  static types = [
    DesignObjectMentionMetadataType.Number
  ];
}
